import { KeyRound, Phone } from 'lucide-react';
import React from 'react';
import { useSelector } from 'react-redux';

import { isRingCentralEnabledForUser } from '@/lib/featureFlags';
import { selectUser } from '@/state/selectors/root-selectors';

import { ClioIntegration } from '../clio';
import { DropboxIntegration } from '../dropbox';
import { GoogleDriveIntegration } from '../google-drive';
import { RingCentralOAuthIntegration } from '../ringcentral';

interface IntegrationsPageProps {
  firmId: string;
}

export const IntegrationsPage: React.FC<IntegrationsPageProps> = ({
  firmId,
}) => {
  const user = useSelector(selectUser);
  const showRingCentral = isRingCentralEnabledForUser(user?.email);

  return (
    <div className="space-y-6">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-indigo-50">
          <KeyRound className="h-5 w-5 text-indigo-600" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-900">
            OAuth Integrations
          </h2>
          <p className="text-sm text-gray-500 mt-0.5">
            Connect and manage third-party service accounts for this firm.
            Each integration uses OAuth to securely authorize access.
          </p>
        </div>
      </div>

      <div className="space-y-4">
        <ClioIntegration firmId={firmId} />
        <DropboxIntegration firmId={firmId} />
        <GoogleDriveIntegration firmId={firmId} />
      </div>

      {showRingCentral && (
        <>
          <div className="flex items-start gap-3 pt-2">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-orange-50">
              <Phone className="h-5 w-5 text-orange-600" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-gray-900">
                Personal Integrations
              </h2>
              <p className="text-sm text-gray-500 mt-0.5">
                These integrations are linked to your personal account, not the
                firm.
              </p>
            </div>
          </div>

          <div className="space-y-4">
            <RingCentralOAuthIntegration />
          </div>
        </>
      )}
    </div>
  );
};
